import { render, staticRenderFns } from "./EditEmailModal.vue?vue&type=template&id=6f7fce26&"
import script from "./EditEmailModal.vue?vue&type=script&lang=ts&"
export * from "./EditEmailModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f7fce26')) {
      api.createRecord('6f7fce26', component.options)
    } else {
      api.reload('6f7fce26', component.options)
    }
    module.hot.accept("./EditEmailModal.vue?vue&type=template&id=6f7fce26&", function () {
      api.rerender('6f7fce26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/profile/email/EditEmailModal.vue"
export default component.exports